import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * `<ExportScopeStep />` — patient elects what to export.
 *
 * Categories drawn from `PatientProjectionContentCategory` +
 * PFO §7.2 export surface. Multi-select; at least one category
 * must be selected to advance.
 */
import * as React from 'react';
import { useLocale } from '../../i18n/locale-context.js';
const CATEGORIES = [
    {
        kind: 'operations-log',
        labelKey: 'export.scope.category.operations_log.label',
        descriptionKey: 'export.scope.category.operations_log.description',
    },
    {
        kind: 'aggregated-payload',
        labelKey: 'export.scope.category.aggregated_payload.label',
        descriptionKey: 'export.scope.category.aggregated_payload.description',
    },
    {
        kind: 'consent-artifacts',
        labelKey: 'export.scope.category.consent_artifacts.label',
        descriptionKey: 'export.scope.category.consent_artifacts.description',
    },
    {
        kind: 'coordination-artifacts',
        labelKey: 'export.scope.category.coordination_artifacts.label',
        descriptionKey: 'export.scope.category.coordination_artifacts.description',
    },
    {
        kind: 'erasure-events',
        labelKey: 'export.scope.category.erasure_events.label',
        descriptionKey: 'export.scope.category.erasure_events.description',
    },
];
export function ExportScopeStep(props) {
    const { t } = useLocale();
    const [selected, setSelected] = React.useState(new Set());
    const toggle = (kind) => {
        setSelected((prev) => {
            const next = new Set(prev);
            if (next.has(kind)) {
                next.delete(kind);
            }
            else {
                next.add(kind);
            }
            return next;
        });
    };
    const handleContinue = () => {
        if (selected.size === 0) {
            return;
        }
        props.onSelectCategories(Array.from(selected));
    };
    return (_jsxs("section", { "aria-labelledby": "scope-heading", children: [_jsx("h3", { id: "scope-heading", children: t('export.scope.heading') }), _jsx("p", { children: t('export.scope.body') }), _jsx("ul", { "aria-label": t('export.scope.categories_aria_label'), children: CATEGORIES.map((c) => (_jsx("li", { children: _jsxs("label", { children: [_jsx("input", { type: "checkbox", checked: selected.has(c.kind), onChange: () => toggle(c.kind) }), ' ', _jsx("strong", { children: t(c.labelKey) }), " \u2014 ", t(c.descriptionKey)] }) }, c.kind))) }), _jsxs("div", { role: "group", "aria-label": t('export.scope.actions_aria_label'), children: [_jsx("button", { type: "button", onClick: handleContinue, disabled: selected.size === 0, children: t('export.scope.continue') }), _jsx("button", { type: "button", onClick: props.onCancel, children: t('export.scope.cancel') })] })] }));
}
//# sourceMappingURL=scope-step.js.map